"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimAndLowerKeyCase = void 0;

var _trimAndLowerCase = require("./0_trimAndLowerCase");

/**
 * remove trailing and leading space of the key
 * also lower the key case
 * does not mutate original object
 * return new object
 * @param {{ [prop: string]: string }} obj - object that you want to work on
 * @return {[prop:string]: string}
 */
var trimAndLowerKeyCase = function trimAndLowerKeyCase(obj) {
  var newObj = {};

  for (var prop in obj) {
    newObj[(0, _trimAndLowerCase.trimAndLowerCase)(prop)] = obj[prop];
  }

  return newObj;
};

exports.trimAndLowerKeyCase = trimAndLowerKeyCase;